



















// @ is an alias to /src
import {Component, Vue} from 'vue-property-decorator';

import { getAuthenticationClient } from '@/authentication/getAuthenticationClient';

@Component({})

export default class Home extends Vue {

    private async logout(){
        const authenticationClient = await getAuthenticationClient();
        await authenticationClient.logout();
    }

}


